module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS4.46522ba7.jpg";